import React from "react";

import { Contants } from "components/constants";
import Share from "components/share";
import Social from "components/social";
import parser from "html-react-parser";

import { Cadastro } from "../../../../data/interfaces";
import {
  Container,
  ContainerPerson,
  Nome,
  Especialidade,
  Image,
  ContainerDados,
  Label,
  Informacao,
  Curriculo,
  Action,
  BoxImage,
  ContainerBoxImage,
  ContainerBoxText,
} from "./styles";

interface OwnProps {
  cadastro: Cadastro;
}

type Props = OwnProps;

export default function Detalhe({ cadastro }: Props) {
  return (
    <Container>
      <ContainerBoxImage>
        <BoxImage>
          <Image src={cadastro.urlImage} alt="Foto" />
        </BoxImage>
        <ContainerBoxText>
          <Image src={cadastro.urlImage} alt="Foto" />
          <Share
            link={`${Contants.LINK_SHARE}/profissional/${cadastro.key}/1`}
            titulo={cadastro.nome}
          />
        </ContainerBoxText>
      </ContainerBoxImage>
      <ContainerPerson>
        <ContainerDados>
          <Nome>{cadastro.nome}</Nome>
          <Especialidade>{cadastro.especialidade}</Especialidade>
          <Action
            href={cadastro.site}
            rel="noreferrer noopener"
            target="_blank"
          >
            <Label>{cadastro.site}</Label>
          </Action>
          <Action
            href={`https://www.google.com/maps/search/?api=1&query=${cadastro.endereco}`}
            rel="noreferrer noopener"
            target="_blank"
          >
            <Label>{cadastro.endereco}</Label>
          </Action>
          <Action href={`tel:${cadastro.telefone}`}>
            <Label>{cadastro.telefone}</Label>
          </Action>
          <Action href={`tel:${cadastro.celular}`}>
            <Label>{cadastro.celular}</Label>
          </Action>
          <Action href={`emailto:${cadastro.email}`}>
            <Label>{cadastro.email}</Label>
          </Action>

          <Action
            href={`https://ActionButtonpi.whatsapp.com/send?phone=${cadastro.whatsap}`}
          >
            <Label>{cadastro.whatsap}</Label>
          </Action>

          <Action
            href={cadastro.urlVideo}
            rel="noreferrer noopener"
            target="_blank"
          >
            <Label>{cadastro.urlVideo}</Label>
          </Action>
          <Label>{`Atende em : ${cadastro.cidades}`}</Label>
        </ContainerDados>
      </ContainerPerson>
      <Social item={cadastro} />
      <Informacao>Informações</Informacao>
      <Curriculo>
        {cadastro.curriculo ? parser(cadastro.curriculo) : ""}
      </Curriculo>
    </Container>
  );
}
